import UISelect from 'UIComponents/input/UISelect';
import UITruncateString from 'UIComponents/text/UITruncateString';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { useMemo } from 'react';
import { FilterEditorWrapper } from '../Filters/FilterEditorWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getOptionWithValue = (options, value) => {
  const arrayValue = Array.isArray(value) ? value : [value];
  if (!options) {
    return arrayValue.map(val => ({
      text: `${val}`,
      value: val
    }));
  }
  if (options[0] && 'options' in options[0]) {
    return arrayValue.reduce((selectedOptions, val) => {
      for (const segmentedOption of options) {
        const selectedOption = segmentedOption.options.find(option => option.value === val);
        if (selectedOption) {
          selectedOptions.push(selectedOption);
          break;
        }
      }
      return selectedOptions;
    }, Array());
  }
  return arrayValue.reduce((selectedOptions, val) => {
    const selectedOption = options.find(option => option.value === val);
    if (selectedOption) {
      selectedOptions.push(selectedOption);
    }
    return selectedOptions;
  }, Array());
};
const BaseSelectEditorComponent = props => {
  const {
    tooltipHeader,
    dataTestId,
    disabled,
    options,
    tooltipText,
    value,
    placeholder
  } = props;
  const tooltipTextValue = useMemo(() => {
    const selectedOptions = value ?
    // @ts-expect-error SelectOptionType is not exported and slightly different than the type Option
    getOptionWithValue(options, value) : Array();
    const optionsText = selectedOptions.map(option => option.text).join(', ');
    return selectedOptions.length ? /*#__PURE__*/_jsx("div", {
      children: optionsText
    }) : null;
  }, [value, options]);
  const renderButtonContent = () => {
    return /*#__PURE__*/_jsx(UITruncateString, {
      tooltip: false,
      maxWidth: 200,
      children: tooltipTextValue || placeholder
    });
  };
  const tooltipContent = () => {
    if (tooltipText) {
      return tooltipText;
    }
    return /*#__PURE__*/_jsxs("div", {
      children: [tooltipHeader, /*#__PURE__*/_jsx("b", {
        children: tooltipTextValue
      })]
    });
  };
  return /*#__PURE__*/_jsx(FilterEditorWrapper, {
    isSelected: !!value,
    "data-test-id": dataTestId,
    children: /*#__PURE__*/_jsx(UITooltip, {
      title: tooltipContent(),
      children: /*#__PURE__*/_jsx(UISelect, Object.assign({}, props, {
        anchorType: "button",
        ButtonContent: renderButtonContent,
        buttonUse: "transparent",
        disabled: disabled,
        menuWidth: 300,
        options: options,
        buttonSize: 'small',
        value: value
      }))
    })
  });
};
export const __TESTABLE__ = {
  getOptionWithValue
};
export default BaseSelectEditorComponent;